import styled from "styled-components";

export const StyledTable = styled.table`
  background-color: white; 
  width: 390pt;
`;

export const StyledTr = styled.tr`
  height: 112.5pt;
`

export const UserDataTd = styled.td`
  width: 100%
`

export const IconsTd = styled.td`
  width: 1%;
  white-space: nowrap;
  text-align: right;
  padding: 0;
  vertical-align: middle;
`

export const SignaturePreviewFrame = styled.div`
  border: 1px solid rgba(31, 43, 58, 0.16);
  border-radius: 4px;
  padding: 6px;
`

export const StyledImg = styled.img`
  width: 382.99pt;
  height: 33.59pt
`;

